const development = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: '/',
  // defaultPath: '/dashboard/default',
  defaultPath: '',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  // Saas ML Modal
  //msal config our azure addd
  // backend_Url:' http://172.172.211.15:11000',  ----> Production
  // backend_Url:'http://172.178.8.184:8000/',
   backend_Url:' https://xynexai.com/api/',
  // backend_Url:' http://172.172.211.15:9000/',   // ----> development
  msal: {
    clientId: '6fe8d5a2-e38b-41f4-bf4d-5c1ed934f532',
    authority: 'https://login.microsoftonline.com/fa734e69-425d-4208-80e6-4dc3a2927500',
    redirectUri: 'https://172.203.236.174:3001/auth/callback'
  },
  nameSpace: '',
};

const config = {
  development
};

// Select config based on environment
const environment = 'development';
export default config[environment];